'use strict';

/**
 * Real-time config related
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.loadConfigDataset = loadConfigDataset;
exports.loadFlowConfig = loadFlowConfig;
exports.extractFlowConfig = extractFlowConfig;
exports.loadServerTimeOffset = loadServerTimeOffset;
exports.computeServerDate = computeServerDate;
exports.extractOfficeState = extractOfficeState;
var DB_REF_BASE_CONFIG = exports.DB_REF_BASE_CONFIG = 'config';
var FIREBASE_HEADERS = { 'Content-type': 'application/json' };

function loadConfigDataset(firebaseUrl, env) {
  return window.fetch(firebaseUrl + '/' + DB_REF_BASE_CONFIG + '/' + env + '.json', { headers: FIREBASE_HEADERS }).then(function (res) {
    return res.json();
  });
}

function loadFlowConfig(firebaseUrl, env, flow) {
  return loadConfigDataset(firebaseUrl, env).then(function (config) {
    return extractFlowConfig(config, flow);
  });
}

function extractFlowConfig(configDataset, flow) {
  var defaultConfig = configDataset['default'];
  var flowConfig = !flow || !configDataset[flow] ? defaultConfig : _extends({}, defaultConfig, configDataset[flow]);
  return flowConfig;
}

/**
 * Open-hours related stuff
 */

var DB_REF_TIME_OFFSET = exports.DB_REF_TIME_OFFSET = '/.info/serverTimeOffset';

function loadServerTimeOffset(firebaseUrl) {
  return window.fetch(firebaseUrl + '/' + DB_REF_BASE_CONFIG + '.json', {
    method: 'OPTIONS',
    headers: FIREBASE_HEADERS
  }).then(function (response) {
    var dateStr = response.headers.get('date');
    return !dateStr ? 0 : new Date(dateStr) - new Date();
  });
}

function computeServerDate(timeOffset) {
  var localDateTime = new Date().getTime();
  return new Date(localDateTime + timeOffset);
}

var WEEK_DAY_INDEX = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

function extractOfficeState(openHoursData, serverDate) {
  if (openHoursData.state !== 'auto') return openHoursData.state;
  if (!openHoursData.table) return 'closed';
  var dayKey = WEEK_DAY_INDEX[serverDate.getDay()];
  var todayHours = openHoursData.table[dayKey] || [];
  for (var i = 0; i < todayHours.length; i++) {
    var _todayHours$i$0$split = todayHours[i][0].split(':'),
        _todayHours$i$0$split2 = _slicedToArray(_todayHours$i$0$split, 2),
        minHourStr = _todayHours$i$0$split2[0],
        minMinuteStr = _todayHours$i$0$split2[1];

    var _todayHours$i$1$split = todayHours[i][1].split(':'),
        _todayHours$i$1$split2 = _slicedToArray(_todayHours$i$1$split, 2),
        maxHourStr = _todayHours$i$1$split2[0],
        maxMinuteStr = _todayHours$i$1$split2[1];

    var minDateTime = new Date(serverDate.getTime()).setHours(parseInt(minHourStr), parseInt(minMinuteStr));
    var maxDateTime = new Date(serverDate.getTime()).setHours(parseInt(maxHourStr), parseInt(maxMinuteStr));
    if (serverDate.getTime() >= minDateTime && serverDate.getTime() <= maxDateTime) {
      return 'open';
    }
  }
  return 'closed';
}


//////////////////
// WEBPACK FOOTER
// ./~/holocron-web-common/lib/firebase-remote-config.js
// module id = 104
// module chunks = 2